<button type="button" [disabled]="isDisabled" (click)="onClick()"
    class="{{ bgColor() }} {{ textColor() }} disabled:bg-gray-200 text-sm flex items-center justify-center focus:outline-none {{ shadow() ? 'hover:shadow-lg' : '' }} rounded-lg {{ textStyle() }} min-h-[40px] {{ fullWidth() ? 'w-full py-2' : padding() }}">

    @if (inProgress) {
    <svg class="{{ textColor() }} animate-spin shrink-0 -ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
        </circle>
        <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
    </svg>
    } @else {
    @if(icon() && icon() !== '') {
    <i class="{{ icon() }} mr-2 flex items-center justify-center"></i>
    }
    }

    <span class="text-nowrap flex items-center">{{ label() }}</span>

    @if(suffixIcon() && suffixIcon() !== '') {
    <i class="{{ suffixIcon() }} ml-2 flex items-center justify-center"></i>
    }
</button>
<!-- Note: min-h-[40px] ensures a consistent height -->